module.exports = __webpack_public_path__ + "static/media/left-lateral-nonflexion-up.ab04b2eb.png";